export const SearchOrigin = {
  STOREFRONT: 'Storefront',
  STOREFRONT_BNG: 'Storefront BNG',
  STOREFRONT_WHOIS: 'Storefront WhoIs',
  DOMAINS_GATE: 'Domains gate',
  DOMAINS_RESULTS_PAGE: 'Domains results page',
  DOMAINS_GATE_ACCOUNT_LEVEL: 'Domains gate - Account Level',
  DOMAINS_RESULTS_PAGE_ACCOUNT_LEVEL: 'Domains results page - Account Level',
  DOMAINS_GATE_BASE44: 'Domains gate - base44',
  DOMAINS_RESULTS_PAGE_BASE44: 'Domains results page - base44',
  STOREFRONT_BUSINESS_EMAIL: 'Storefront Business Email',
  STOREFRONT_WIXEL: 'Storefront Wixel',
  DOMAINS_GATE_BUSINESS_EMAIL: 'Domains gate - Business Email',
  DOMAINS_RESULTS_PAGE_BUSINESS_EMAIL: 'Domains results page - Business Email',
  DOMAINS_GATE_MAIN_FUNNEL: 'Domains gate - Main Funnel',
  DOMAINS_RESULTS_PAGE_MAIN_FUNNEL: 'Domains results page - Main Funnel',
  DOMAINS_GATE_MAIN_FUNNEL_AI_CHAT: 'Domains gate - Main Funnel AI Chat',
  DOMAINS_RESULTS_PAGE_MAIN_FUNNEL_AI_CHAT: 'Domains results page - Main Funnel AI Chat',
  PREMIUM_SUCCESS_PAGE: 'Premium success page',
  FOCUS_WIDGET: 'focusWidget',
  CHAT_DOMAIN: 'chat_domain',
  NON_AI_SETUP: 'non_ai_setup',
  OLD_CONCIERGE: 'Old concierge',
  RESELLER_CONNECT: 'reseller-connect',
  STOREFRONT_MOBILE_GATE: 'storefront_mobile_gate'
};
// URL / referrer substrings that identify the Business Email search surfaces.
// Shared so the FED BI resolvers key off a single source of truth: the
// Storefront anonymous gate renders under `/business-email`, and the BM
// site-level mailbox flow lands with the token as a query-param value —
// under `referralInfo` on desktop and `referralAdditionalInfo` on mobile.
export const BUSINESS_EMAIL_URL_TOKEN = 'business-email';
export const MAILBOX_SITE_LEVEL_REFERRAL = 'my-mailboxes-site-level';
export const WIXEL_REFERRAL = 'wixel';
const SEARCH_ORIGIN_VALUES = new Set(Object.values(SearchOrigin));
export const isSearchOrigin = value => typeof value === 'string' && SEARCH_ORIGIN_VALUES.has(value);

// Entry tokens whose `referralAdditionalInfo` value differs from the
// SearchOrigin it identifies. Most tokens are spelled the same as their origin
// (`chat_domain`, `non_ai_setup`) and pass the membership check as-is; these do
// not, so they are translated rather than dropped to the fallback.
const REFERRAL_TOKEN_TO_SEARCH_ORIGIN = {
  'dashboard-focus-widget': SearchOrigin.FOCUS_WIDGET
};
export const toSearchOrigin = _ref => {
  let {
    value,
    fallback
  } = _ref;
  if (typeof value === 'string' && REFERRAL_TOKEN_TO_SEARCH_ORIGIN[value]) {
    return REFERRAL_TOKEN_TO_SEARCH_ORIGIN[value];
  }
  return isSearchOrigin(value) ? value : fallback;
};
//# sourceMappingURL=searchOrigin.js.map